import { render, staticRenderFns } from "./TeamEditModal.vue?vue&type=template&id=010fcabb&scoped=true&"
import script from "./TeamEditModal.vue?vue&type=script&lang=js&"
export * from "./TeamEditModal.vue?vue&type=script&lang=js&"
import style0 from "./TeamEditModal.vue?vue&type=style&index=0&id=010fcabb&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "010fcabb",
  null
  
)

export default component.exports